<template>
  <div>
    <b-modal
      ref="modal"
      title="Novo Contas a Pagar"
      header-class="border-bottom-0"
      footer-class="border-top-0"
      size="lg"
      no-close-on-backdrop
    >
      <div class="container-fluid">
        <!-- form  -->
        <div class="row">
          <div class="col-md-12">
            <search-input
              :alias="form.vendor_id.alias"
              v-model="form.vendor_id.value"
              :displayedValue="form.name.value"
              :form="form"
              :name="'vendor_id'"
              @search="searchPerson($event)"
              :searchResult="persons"
              :isLoading="loading"
              @selected="setPerson($event)"
            >
              <search-input-option
                v-for="(row, index) in persons.data"
                :key="index"
                :index="index"
                @click="setPerson(row)"
              >
                <div>{{ row.name }}</div>
              </search-input-option>
            </search-input>
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <text-input
              v-model="form.description.value"
              :alias="form.description.alias"
            />
          </div>
          <div class="col-6">
            <account-plan-search
              @accountPlanSelected="setAccountPLan($event)"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="control-label">Histórico:</label>
              <textarea
                v-model="form.history.value"
                maxlength="500"
                class="form-control"
                id="exampleFormControlTextarea1"
                rows="5"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="row" v-for="(row, index) in parcels" :key="index">
          <div class="col-md-4">
            <text-input v-model="row.document" alias="Documento" />
          </div>
          <div class="col-md-3 col-5">
            <number-input v-model="row.value" alias="Valor" />
          </div>
          <div class="col-md-4 col-5">
            <date-input v-model="row.due_date" alias="Vencimento" />
          </div>
          <div class="col-md-1 col-2">
            <div class="form-group">
              <label class="control-label">&nbsp;</label>
              <br />
              <button
                class="btn btn-sm btn-light"
                v-if="hasMoreThanOneParcelRow"
                @click="deleteParcelRow(index)"
              >
                <i class="text-info fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <button class="btn btn-link text-info" @click="addParcelRow()">
              <i class="fas fa-plus"></i> Adicionar parcela
            </button>
            <br />
            <button class="btn btn-link text-info" @click="openCalcParcel()">
              <i class="fas fa-calculator" /> Gerar de Parcelas
            </button>
          </div>
        </div>
      </div>

      <br />

      <error-handler :error="error" />
      <calc-parcel ref="calcParcel" @parcels="setParcels($event)" />

      <b-alert
        :show="alertData.isVisible"
        fade
        variant="danger"
        @dismissed="alertData.isVisible = false"
        dismissible
        >{{ alertData.message }}</b-alert
      >

      <!-- form  -->

      <div slot="modal-footer">
        <button
          role="button"
          class="btn btn-outline-secondary"
          @click="$refs.modal.hide()"
        >
          <i class="fas fa-times"></i> Cancelar
        </button>
        <button
          role="button"
          class="btn btn-success"
          style="margin-left: 5px"
          @click="store"
        >
          <i class="fas fa-check"></i> Salvar
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import Form from "./../../../mixins/Form.js";
import CalcParcel from "./../../sections/CalcParcel";
import accountPlanSearch from "../../account/search/accountPlanSearch";

export default {
  components: { CalcParcel, accountPlanSearch },

  data: function () {
    return {
      form: new Form({
        vendor_id: {
          alias: "Fornecedor",
        },

        name: {},

        description: {
          alias: "Descrição",
        },

        history: {},

        account_plan_id: {
          alias: "Plano de Contas",
          validate: {
            required: true,
          },
        },
      }),

      accountPlansList: {},

      parcels: [
        {
          document: null,

          value: 0,

          due_days: null,

          due_date: null,
        },
      ],

      selectedPerson: null,

      loading: false,

      error: null,

      alertData: {
        isVisible: false,
        message: null,
      },
    };
  },

  created() {
    this.getAccountPlans();
  },

  computed: {
    accountPlanOptions() {
      var options = {};

      for (let index in this.accountPlansList) {
        options[this.accountPlansList[index].id] = this.accountPlansList[
          index
        ].description;
      }
      return options;
    },
    persons() {
      return this.$store.state.person.persons;
    },
  },

  methods: {
    open() {
      this.resetForm();

      this.getAccountPlans();
      
      var search={page :1}
      this.searchPerson(search);

      this.$refs.modal.show();
    },

    hasMoreThanOneParcelRow() {
      return this.parcels.length > 1;
    },

    getAccountPlans() {
      this.$store
        .dispatch("accountPlan/getAccountPlansList")
        .then((response) => {
          this.accountPlansList = response.data.accountPlans;
        })
        .catch((error) => {
          console.log(error);
          this.error = error;
        });
    },

    searchPerson(search) {
      this.loading = true;

      this.$store
        .dispatch("person/getPersons", {
          page: search.page,
          name: search.text,
          type: "v",
          status: 1,
        })
        .then((response) => {
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.error = error;
        });
    },

    addParcelRow() {
      this.parcels.push({
        document: null,
        value: 0,
        due_days: null,
        due_date: null,
      });
    },

    deleteParcelRow(index) {
      this.$delete(this.parcels, index);
    },

    setPerson(person) {
      this.selectedPerson = person;

      this.form.vendor_id.value = person.id;

      this.form.name.value = person.name;
    },

    resetForm() {
      this.error = null;

      this.alertData.isVisible = false;

      this.form.reset();

      this.parcels = [
        {
          document: null,
          value: 0,
          due_days: null,
          due_date: null,
        },
      ];
    },

    setAccountPLan(accountplan) {
      this.form.account_plan_id.value = accountplan.id;
    },

    getParams() {
      let params = this.form.getValues();

      params.parcels = this.parcels;

      return params;
    },

    openCalcParcel() {
      this.$refs.calcParcel.open();
    },

    setParcels(parcels) {
      this.parcels = parcels;
    },

    store() {
      this.$store.commit("showLoading");
      this.$store
        .dispatch("billpayable/postInsertBillPayable", this.getParams())
        .then((response) => {
          this.$refs.modal.hide();
          this.$emit("stored");
          this.$store.commit("showAlert", {
            message: "Lançamento efetuado!",
            type: "success",
          });
          return;
        })
        .catch((error) => {
          this.error = error;
          this.$store.commit("hideLoading");
        });
    },
  },
};
</script>
